import React from 'react';

import { useMediaQuery, useTheme, Container, Typography } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import {
  StyledPartnerInfoContainer,
  StyledPartnerCard,
  StyledPartnerCardInfo,
  StyledPartnerLink,
  StyledPartnerCardsContainer,
} from './styled/HealthPartnerPage';
import { imgLinks } from '../shared';

const HealthPartnerPage = () => {
  const theme = useTheme();
  const isSmScreen = useMediaQuery(theme.breakpoints.down('tablet'));

  const getSundayCardImage = isSmScreen ? imgLinks['sunday-icon-sm'] : imgLinks['sunday-icon-lg'];
  const getAwareCardImage = isSmScreen ? imgLinks['aware-icon-sm'] : imgLinks['aware-icon-lg'];
  return (
    <Container>
      <StyledPartnerInfoContainer>
        <Typography variant="h1">
          <FormattedMessage id="vitolo.partner.page.title" />
        </Typography>
        <Typography variant="p">
          <FormattedMessage id="vitolo.partner.page.description" />
        </Typography>
      </StyledPartnerInfoContainer>
      <StyledPartnerCardsContainer>
        <StyledPartnerLink variant="nostyle" to="/aware-partner-info">
          <StyledPartnerCard>
            <img src={getAwareCardImage} alt="aware-placeholder" />
            <StyledPartnerCardInfo>
              <Typography variant="h3">
                <FormattedMessage id="vitolo.partner.page.aware.card.title" />
              </Typography>
              <Typography variant="p">
                <FormattedMessage id="vitolo.partner.page.aware.card.description" />
              </Typography>
            </StyledPartnerCardInfo>
          </StyledPartnerCard>
        </StyledPartnerLink>

        <StyledPartnerLink variant="nostyle" to="/sunday-partner-info">
          <StyledPartnerCard>
            <img src={getSundayCardImage} alt="sunday-placeholder" />
            <StyledPartnerCardInfo>
              <Typography variant="h3">
                <FormattedMessage id="vitolo.partner.page.sunday.card.title" />
              </Typography>
              <Typography variant="p">
                <FormattedMessage id="vitolo.partner.page.sunday.card.description" />
              </Typography>
            </StyledPartnerCardInfo>
          </StyledPartnerCard>
        </StyledPartnerLink>
      </StyledPartnerCardsContainer>
    </Container>
  );
};

export default HealthPartnerPage;
